import { getState } from '$setup/redux'
import { disconnectionCallbackManager } from '$hooks/after/disconnection'

const UserWaitEventName = 'USER_WAIT'

export enum UserWaitPendingAction {
  WEB_SOCKET_CONNECTION = 'web-socket-connection',
  UPDATE_APP = 'update-app',
  LOAD_CHAT = 'load-chat',
  LOAD_MORE_MESSAGES = 'load-more-messages',
  UPLOAD = 'upload',
  JOIN_CALL = 'join-call',
  START_CALL = 'start-call',
  REJECT_INCOMING_CALL = 'reject-incoming-call',
  LOAD_SHARED_MEDIA = 'load-shared-media',
  DOWNLOAD = 'download',
}

const DEFAULT_MINIMUM_PENDING_DURATION = 0

export function reportUserWait(
  pendingAction: UserWaitPendingAction,
  duration: number,
  disconnectedDuringPending: boolean,
  additionalData?: Record<string, unknown>,
) {
  analite(UserWaitEventName, {
    pendingAction,
    duration,
    disconnectedDuringPending,
    ...additionalData,
  })
}

export function createUserWaitReporter(
  pendingAction: UserWaitPendingAction,
  minimumPendingDurationToReportMS = DEFAULT_MINIMUM_PENDING_DURATION,
  reportIfDisconnectedDuringPending = true,
  sendAnalyticsRequest = true,
) {
  let startTime: number = -1
  let disconnectedDuringPending = false

  const onDisconnect = () => {
    disconnectedDuringPending = true
  }

  const start = () => {
    disconnectionCallbackManager.removeCallback(onDisconnect)
    startTime = performance.now()
    const state = getState()
    if (
      state.view.main.connectionStatus !== 'connected' &&
      pendingAction !== UserWaitPendingAction.UPDATE_APP && // when app is loading, initial status of socket is never connected.
      pendingAction !== UserWaitPendingAction.WEB_SOCKET_CONNECTION
    ) {
      disconnectedDuringPending = true
    } else disconnectionCallbackManager.addCallback(onDisconnect)
  }

  const clear = () => {
    startTime = -1
    disconnectionCallbackManager.removeCallback(onDisconnect)
    disconnectedDuringPending = false
  }

  const getDurationFromStart = () => {
    return performance.now() - startTime
  }

  const end = (
    data?: Record<string, unknown>,
  ): false | { duration: number; disconnectedDuringPending: boolean } => {
    if (startTime === -1) return false
    const duration = performance.now() - startTime

    if (
      minimumPendingDurationToReportMS < duration &&
      (reportIfDisconnectedDuringPending || !disconnectedDuringPending) &&
      sendAnalyticsRequest
    ) {
      reportUserWait(pendingAction, duration, disconnectedDuringPending, data)
    }

    clear()
    return { duration, disconnectedDuringPending }
  }

  return { start, end, clear, getDurationFromStart }
}
